// extracted by mini-css-extract-plugin
export default {"languages":"Languages_languages__CnfMt","active":"Languages_active__Nb6Yx"};